export default {
  meta: {
    title: $localize`:@@payment.payment_bonuses.page_title:Бонусы к пополнению`
  }
};